import { render } from "./ONG.vue?vue&type=template&id=113c65df&scoped=true"
const script = {}

import "./ONG.vue?vue&type=style&index=0&id=113c65df&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113c65df"]])

export default __exports__